import React, { useEffect, useState } from 'react';

import Info from '../Info/Info';
import QuillEditor from '../../UI/QuillEditor/QuillEditor';

import classes from './Input.module.scss';

const Input = props => {
    const [editorState, setEditorState] = useState(props.data.value)
    let formElement = null;
    let invalid = !props.data.valid && props.data.touched;

    useEffect(() => {
        if (props.data.type === 'editor') {
            props.changed(props.id, editorState)
        }
    }, [editorState])

    switch (props.data.element) {
        case 'input':
            formElement = <div className={classes.Input}>
                <label className={classes.InputLabel}>{props.data.label}</label>
                <input
                    className={invalid ? classes.TextInputInvalid : classes.TextInput}
                    type={props.data.type}
                    placeholder={props.data.placeholder}
                    ref={props.data.ref}
                    value={props.data.value}
                    disabled={!props.disabled}
                    onChange={() => props.changed(props.data.type, props.id)} />
                {invalid && <small className={classes.ErrorMessage}>{props.data.errorMessage}</small>}
            </div>
            break;
        case 'checkbox':
            formElement = <div className={classes.Input}>
                <div className={classes.Checkbox}>
                    <div className={!props.data.value ? classes.CheckboxInputContainerInvalid : classes.CheckboxInputContainer}>
                        {/* <span className={classes.CheckboxInputBox}> */}
                            <input
                                className={classes.CheckboxInput}
                                type={props.data.type}
                                ref={props.data.ref}
                                checked={props.data.value}
                                onChange={() => props.changed(props.data.type, props.id)} />
                        {/* </span> */}
                    </div>
                    <label className={classes.CheckboxLabel}>{props.data.label}</label>
                </div>
                {invalid && <small className={classes.ErrorMessage}>{props.data.errorMessage}</small>}
            </div>
            break;
        case 'textarea':
            formElement = <div className={!props.disabled ? classes.InputHidden : classes.Input}>
                <label className={classes.InputLabel}>{props.data.label}</label>
                <textarea
                    className={invalid ? classes.TextAreaInvalid : classes.TextArea}
                    type={props.data.type}
                    placeholder={props.data.placeholder}
                    rows={props.data.rows}
                    disabled={!props.disabled}
                    ref={props.data.ref}
                    value={props.data.value}
                    onChange={() => props.changed(props.data.type, props.id)} />
                {invalid && <small className={classes.ErrorMessage}>{props.data.errorMessage}</small>}
            </div>
            break;
        case 'select':
            formElement = <div className={classes.Input}>
                <label className={classes.InputLabel}>{props.data.label}</label>
                <select
                    className={classes.Select}
                    value={props.data.value}
                    ref={props.data.ref}
                    onChange={() => props.changed(props.data.type, props.id)}>
                    {props.data.options.map(option => (
                        <option key={option.value} value={option.value} className={classes.SelectOption}>
                            {option.displayValue}
                        </option>
                    ))}
                </select>
            </div>
            break;
        case 'editor':
            formElement = <div className={classes.Editor}>
                <QuillEditor
                    label={props.data.label}
                    state={editorState}
                    onStateChange={setEditorState}
                    placeholder={props.data.placeholder}
                    config={{
                        required: props.data.validation.required,
                        minLength: props.data.validation.minLength,
                        errorMessage: props.data.errorMessage
                    }} />
            </div>
            break;
        case 'hline':
            formElement = <div className={classes.Input}>
                <div className={classes.HorizontalLine}></div>
            </div>
            break;
        case 'header':
            formElement = <div className={classes.Input}>
                <h3 className={classes.Header}>{props.data.header}</h3>
            </div>
            break;
        case 'info':
            formElement = <Info withIcon={props.data.icon} type={props.data.type}>{props.data.comment}</Info>
            break;
        default:
            formElement = <div className={classes.Input}>
                <label className={classes.InputLabel}>{props.data.label}</label>
                <input
                    className={invalid ? classes.TextInputInvalid : classes.TextInput}
                    type={props.data.type}
                    placeholder={props.data.placeholder}
                    ref={props.data.ref}
                    value={props.data.value}
                    onChange={() => props.changed(props.data.type, props.id)} />
                {invalid && <small className={classes.ErrorMessage}>{props.data.errorMessage}</small>}
            </div>
    }
    return formElement;
}

export default Input;